import { ROLE_TYPES, type StatusDelivery } from '@/Interfaces/Data';
import { ENUM_DELIVERY_TYPE } from '@/_features/deliveries/constants';

export const MONITOR_DELIVERIES_PERMISSIONS = [
  ROLE_TYPES.ADMIN,
  ROLE_TYPES.SUPPORT,
];

export enum EMonitorTab {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  LATE = 'LATE',
  REOPENED = 'REOPENED',
}

export const TRANSLATE_MONITOR_TAB: Record<EMonitorTab, string> = {
  [EMonitorTab.PENDING]: 'Pendente',
  [EMonitorTab.IN_PROGRESS]: 'Em andamento',
  [EMonitorTab.LATE]: 'Atrasado',
  [EMonitorTab.REOPENED]: 'Reaberto',
};

export enum ESlaLevel {
  OK = 'OK',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

export enum EMonitorRouteStepType {
  PENDING = 'PENDING',
  ASSOCIATED = 'ASSOCIATED',
  ACCEPTED = 'ACCEPTED',
  ARRIVED_STORE = 'ARRIVED_STORE',
  LEFT_STORE = 'LEFT_STORE',
  ARRIVED_CLIENT = 'ARRIVED_CLIENT',
  DELIVERED = 'DELIVERED',
  RETURNED_STORE = 'RETURNED_STORE',
  FINISHED = 'FINISHED',
}

export const SLA_WARNING_MINUTES = 25;
export const SLA_CRITICAL_MINUTES = 45;
export const NEW_DELIVERY_MINUTES = 5;
export const MONITOR_CLOCK_INTERVAL = 60000;

export enum EMonitorIndicatorsKey {
  CLOUD = 'cloud',
  LINKED = 'linked',
  TOTAL = 'total',
}

export const MONITOR_INDICATORS_KEY_BY_DELIVERY_TYPE: Record<
  ENUM_DELIVERY_TYPE,
  EMonitorIndicatorsKey
> = {
  [ENUM_DELIVERY_TYPE.CLOUD]: EMonitorIndicatorsKey.CLOUD,
  [ENUM_DELIVERY_TYPE.LINKED]: EMonitorIndicatorsKey.LINKED,
};

export enum EIndicatorTrend {
  UP = 'UP',
  DOWN = 'DOWN',
}

export const GET_MONITOR_DELIVERIES = 'monitor';

export const MONITOR_REFETCH_INTERVAL = 30000;
export const MONITOR_CODE_SEARCH_DEBOUNCE = 500;
export const MONITOR_PAGE_SIZE = 30;
export const MONITOR_LOAD_MORE_SKELETON_CARDS = 5;
export const MONITOR_LOAD_MORE_ROOT_MARGIN = '400px';
export const MONITOR_BACK_TO_TOP_OFFSET = 600;

export const MONITOR_SEARCH_PARAMS = {
  CITY_ID: 'cityId',
  TAB: 'tab',
  CODE: 'code',
  DELIVERY_TYPE: 'deliveryType',
  DELIVERY_ID: 'deliveryId',
};

export const GET_MONITOR_DELIVERY_DETAIL = 'monitor-detail';

export const MONITOR_CURRENT_STEP_LABEL: Partial<
  Record<StatusDelivery, string>
> = {
  ASSOCIADO: 'Aguardando aceite',
  ACEITO: 'Indo à loja',
  CHEGOU_NA_LOJA: 'Na loja',
  SAIU_DA_LOJA: 'A caminho',
  CHEGOU_NO_CLIENTE: 'No cliente',
};

export const MONITOR_CURRENT_STEP_FALLBACK_LABEL = 'Status atual';

export const MONITOR_EXIT_STATUSES: StatusDelivery[] = [
  'CANCELADO',
  'FINALIZADO',
];

export const GET_MONITOR_INDICATORS = 'monitor-indicators';
